import { render, staticRenderFns } from "./DividirPago.vue?vue&type=template&id=030b9191&"
import script from "./DividirPago.vue?vue&type=script&lang=js&"
export * from "./DividirPago.vue?vue&type=script&lang=js&"
import style0 from "./DividirPago.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports